import { AxiosResponse } from 'axios';
import { UserTeamsPayload } from 'components/usersTable/types';
import { config } from 'config/config.local';
import { BUSINESS_PYTHON } from './axios';

export interface UpdateInviteLinkPayload {
  assign_license: boolean;
  assign_skill_dive?: boolean;
  teams: UserTeamsPayload[];
  inviteId?: string;
}

// `teams` comes back as team IDs only, without `is_manager`.
export interface InviteLinkResponse {
  id: string;
  assign_license: boolean;
  assign_skill_dive?: boolean;
  teams: string[];
}

export const getInviteLink = (
  data: UpdateInviteLinkPayload
): Promise<AxiosResponse<InviteLinkResponse>> => {
  return BUSINESS_PYTHON.post(`${config.routes.users.getInviteLink}`, { ...data });
};

export const getUpdatedInviteLink = (
  data: UpdateInviteLinkPayload
): Promise<AxiosResponse<InviteLinkResponse>> => {
  const inviteId = data.inviteId;
  delete data['inviteId'];
  return BUSINESS_PYTHON.put(`${config.routes.users.getInviteLink}${inviteId}/`, { ...data });
};
